

class TemplateRegistry {
}

TemplateRegistry.templates = {};

export default TemplateRegistry;